export const getVerifyFundingAccountInitialValues = () => ({
  microDeposit_1: '',
  microDeposit_2: '',
});
